import { render, staticRenderFns } from "./RegistrationList.vue?vue&type=template&id=cc1b0680"
import script from "./RegistrationList.vue?vue&type=script&lang=js"
export * from "./RegistrationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports